import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IBookmark } from "../../../../documaker/domain/format/objects";

export interface IBookmarkPropertyEditable {
  bookmark(): IPropertyEditable<IBookmark>;
}

export function instanceOfIBookmarkPropertyEditable(instance: any): instance is IBookmarkPropertyEditable {
  return instance
      && instance.bookmark
      && instanceOfIPropertyEditable<IBookmark>(instance.bookmark());
}
